// Firebase

import { doc, getDoc } from 'firebase/firestore/lite'
import { db } from '@/main'

export default {
    methods: {
        async getEvent(eventId) {
            const docRef = doc(db, 'belegungsplan', eventId)
            const docSnap = await getDoc(docRef)

            if (docSnap.exists()) {
                this.currentEvent = docSnap.data()
            } else {
                console.log('No event was found')

            }
        }
    }
}